import { ErpAdditionalMessageDto } from './../../common/model/erpadditionalmessagedto';
import { WebTimeRecord } from './../model/webtimerecord';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { WebTimeRecordType } from '../model/webtimerecordtype';

@Injectable()
export class TimeManagementService {

    constructor( private readonly backendService: HisBackendService ) { }

    /**
     * Save a web time record
     *
     * @param recordType web time record type (come, leave, business_errand)
     */
    createWebTimeRecord( recordType: WebTimeRecordType ): Observable<ErpAdditionalMessageDto<WebTimeRecord>> {
        return this.backendService.postData( 'api/v1/rm/erp/timemanagement/webtimerecord', new WebTimeRecord( recordType, new Date() ) );
    }

    /**
     * Retrieve last web time record
     *
     * @returns last web time record
     */
    getLastWebTimeRecord(): Observable<WebTimeRecord> {
        return this.backendService.getData( 'api/v1/rm/erp/timemanagement/webtimerecord/last' );
    }

    /**
     * Retrieve system key value and user chip activation status
     * for displaying the business errand button
     *
     * @returns value for displaying the business errand button
     */
    isBusinessErrandActive(): Observable<boolean> {
        return this.backendService.getData( 'api/v1/rm/erp/timemanagement/webtimerecord/businesserrand/active' );
    }

    /**
     * Retrieve user chip activation status
     *
     * @returns value for present and activated time chip
     */
    isTimeChipPresentAndActive(): Observable<boolean> {
        return this.backendService.getData( 'api/v1/rm/erp/timemanagement/webtimerecord/timechip/active' );
    }

    /**
     * Retrieve the default booking type
     *
     * @returns value for the default booking type
     */
    getDefaultBookingType(): Observable<string> {
        return this.backendService.getData( 'api/v1/rm/erp/timemanagement/webtimerecord/bookingtype/default' );
    }
}
